import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import TagsField from '../../form-fields/upload/tags'
import { CreationToolUploadContext } from '../manager'

const Tags = styled(TagsField)`
    grid-column: span 4;
    margin-bottom: -10px;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadTagsField = ({ className, field, sourceId }: Props) => {
    const { uploadSources, tags, addTags, removeTags } = useContext(CreationToolUploadContext)
    const [displayTags, setDisplayTags] = useState<string[]>([])

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            if (source) {
                setDisplayTags(source.tags.map(t => t.text))
            }
        } else {
            setDisplayTags(tags.map(t => t.text))
        }
    }, [tags, sourceId, uploadSources])

    return (
        <Tags
            {...{
                className,
                field,
                isBulk: uploadSources.length > 1 && !sourceId,
                showInstructions: !sourceId,
                tags: displayTags,
                onAdd: tags =>
                    addTags(
                        tags.map(text => ({ text })),
                        sourceId
                    ),
                onRemove: tag => removeTags([tag], sourceId),
            }}
        />
    )
}

export default CreationUploadTagsField
